import { gql } from '@apollo/client/core';
import { executeQuery } from '@/components/commons/utils';
import { UrlUtils } from '@/pixel/index';
import Tracking from '@/components/commons/Tracking';

const UGC_SOURCE = 'pixlee';

export const UGC_QUERY = gql`
  query UGC($ugcrequest: UGCRequest) {
    ugc(ugcRequest: $ugcrequest) {
      data {
        id
        avatar_url
        user_name
        platform_link
        photo_title
        products {
          image
          link
          sku
          title
          description
        }
        album_photo_id
        source
        content_type
        small_image_url
        large_image_url
        source_image_url
      }
      next
      page
      success
      total
    }
  }
`;

async function apolloQuery(params) {
  try {
    const { ugc } = await executeQuery(UGC_QUERY, {
      ugcrequest: params
    });

    return JSON.parse(JSON.stringify(ugc));
  } catch (error) {
    console.error(error);
    Tracking.sentryCaptureError(error);
  }
}

export async function loadImageFromUrl(key = 'social_media_id') {
  const mediaId = UrlUtils.getQueryParameter(key);

  if (mediaId) {
    return loadImage(mediaId);
  }
  return null;
}

export async function loadSkuImages(skuId, page, pageSize) {
  return await apolloQuery({ 
    source: UGC_SOURCE, 
    type: 'product',
    skuId, 
    page, 
    pageSize 
 });
}

export async function loadAlbumImages(albumId, page, pageSize) {
  return await apolloQuery({ 
    source: UGC_SOURCE, 
    type: 'product',
    page,  
    pageSize,
    albumId: Number.isNaN(albumId) ? albumId : Number.parseInt(albumId, 10),
 });
}

export async function loadHomeImages(page, pageSize) {
  return await apolloQuery({ 
    source: UGC_SOURCE, 
    type: 'home',
    page, 
    pageSize 
 });
}

export async function loadImage(mediaId) {
  return await apolloQuery({ 
    source: UGC_SOURCE, 
    mediaId,
 });
}
